export default "__VITE_ASSET__142f69fa__"